import GlobalStyles from "../assets/styles/GlobalStyles";
import MetaTags from "../common/layout/MetaTags";
import NotFound from "../components/section/notFound";


const NotFoundPage = () => {
  return (
    <>
      <MetaTags />
      <GlobalStyles />
      <NotFound />
    </>
  );
};

export default NotFoundPage;
